import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, message, Space, Typography, Upload, type UploadProps } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../styledComponent';
import {
  A_MB,
  DEFAULT_MAX_FILE_SIZE,
  DEFAULT_MAXIMUM_FILES,
  hasUploadedFile,
  TEN_MB,
} from '../../../../../components/form';
import { MessageType } from '../../../../../models/MessageType';
import { RcFile } from 'antd/es/upload';

const { Title, Text } = Typography;

function SupplementaryDocumentCard() {
  const { t } = useTranslation();
  const [attachments, setAttachments] = useState<UploadFile[]>([]);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (attachments?.length >= DEFAULT_MAXIMUM_FILES) {
      message[MessageType.WARNING](t('common.error.noOfFilesExceeds', { amount: DEFAULT_MAXIMUM_FILES }));
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [attachments?.length, t]);

  const attachmentUploadProps: UploadProps = {
    fileList: attachments,
    listType: 'picture',
    beforeUpload: (file) => {
      if (file.size > DEFAULT_MAX_FILE_SIZE) {
        message[MessageType.ERROR](t('common.error.sizeExceeds', { amount: TEN_MB / A_MB }));
        return Upload.LIST_IGNORE;
      }
      if (hasUploadedFile(attachments as RcFile[], file)) {
        message[MessageType.ERROR](t('common.error.notAllowUploadSameDocument'));
        return Upload.LIST_IGNORE;
      }
      setAttachments([...attachments, file]);
      return false;
    },
    onRemove: (file) => {
      const index = attachments.indexOf(file);
      const newAttachmentsList = attachments.slice();
      newAttachmentsList.splice(index, 1);
      setAttachments(newAttachmentsList);
    },
  };

  return (
    <Card
      id="supplementary-documents"
      title={
        <Space align="center" size="middle">
          <Title level={3} type="secondary">
            {2}
          </Title>
          <Title level={4}>{t('benefits.surgery.attachmentTitle')}</Title>
        </Space>
      }
    >
      <Form.Item
        name="attachments"
        label={
          <Space>
            <Text>{t('benefits.surgery.referralLetter')}</Text>
          </Space>
        }
      >
        <Upload name="documents" {...attachmentUploadProps}>
          <Button disabled={disabled} icon={<UploadOutlined />}>
            {t('benefits.surgery.uploadButton')}
          </Button>
        </Upload>
      </Form.Item>
    </Card>
  );
}

export default SupplementaryDocumentCard;
